import { render, staticRenderFns } from "./MoreMenuItemDefault.vue?vue&type=template&id=a68a4176&scoped=true&"
import script from "./MoreMenuItemDefault.vue?vue&type=script&lang=ts&"
export * from "./MoreMenuItemDefault.vue?vue&type=script&lang=ts&"
import style0 from "./MoreMenuItemDefault.vue?vue&type=style&index=0&id=a68a4176&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68a4176",
  null
  
)

export default component.exports